module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Peter Golenbock\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Peter Golenbock ")]), _vm._v("is the author or coauthor of twenty previous books, including the "), _c('I', [_vm._v("New York Times")]), _vm._v(" bestsellers "), _c('I', [_vm._v("The Bronx Zoo")]), _vm._v(" and "), _c('I', [_vm._v("Number 1")]), _vm._v(", and more recently, "), _c('I', [_vm._v("Cowboys Have Always Been My Heroes.")]), _vm._v(" He lives in Florida.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/mJtvmz/tc-custom/9781429904803.jpg?1731883366413",
      "alt": "This image is the cover for the book Wrigleyville"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Wrigleyville\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("For celebrated ")]), _c('b', [_vm._v("sportswriter")]), _c('b', [_vm._v(" Peter Golenbock,")]), _c('i', [_c('b', [_vm._v("Wrigleyville ")])]), _c('b', [_vm._v("is a symbol of America's fidelity to its greatest sport. ")]), _c('br'), _c('br'), _vm._v("As he did with classics of sports literature, "), _c('i', [_vm._v("Bums")]), _vm._v(" (a history of the Brooklyn Dodgers) and "), _c('i', [_vm._v("Dynasty ")]), _vm._v("(a history of the New York Yankees), Golenbock turns to a team that has won and broken the hearts of generations of fans; the Chicago Cubs.  Utilizing dozens of personal interviews with players, coaches, fans, sportswriters, and clubhouse personnel, as well as out-of-print memoirs by nineteenth-century players, Peter Golenbock has created a perfect gift for every baseball fan: a book that entertains, warms the heart, and touches the soul. "), _c('br'), _c('br'), _vm._v("This updated edition includes material on Harry Caray's death, the magical seasons of Sammy Sosa and Kerry Wood, and the Cubs' 1998 playoff dive.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0